// components/Card.js - Reusable Card Component with CSS
import React from "react";
import {
  Users,
  School,
  Map,
  DollarSign,
  TrendingUp,
  Activity,
  Minus,
  ArrowRight,
} from "lucide-react";
import "../../styles/card.css";
import {
  FiUsers,
  FiBox,
  FiTrendingUp,
  FiDollarSign,
  FiUserX,
  FiSlash,
  FiMap,
} from "react-icons/fi";
import { useNavigate } from "react-router-dom";

const Card = ({
  title,
  value,
  change,
  changeType, // 'up', 'down', or 'neutral'
  changeText,
  icon,
  color = "blue",
  navito,
}) => {
  const iconMap = {
    users: <FiUsers />,
    school: <FiBox />, // ✅ ADD
    map: <FiMap />, // ✅ ADD
    dollar: <FiDollarSign />, // ✅ ADD
    "user-x": <FiUserX />,
    slash: <FiSlash />,
  };
  const navigate = useNavigate();
  const getColorClass = (color) => {
    switch (color) {
      case "blue":
        return "card-icon-blue";
      case "green":
        return "card-icon-green";
      case "orange":
        return "card-icon-orange";
      case "purple":
        return "card-icon-purple";
      case "red":
        return "card-icon-red";
      case "pink":
        return "card-icon-pink";
      default:
        return "card-icon-blue";
    }
  };

  const getChangeClass = (type) => {
    switch (type) {
      case "up":
        return "card-change-up";
      case "down":
        return "card-change-down";
      case "neutral":
        return "card-change-neutral";
      default:
        return "card-change-neutral";
    }
  };

  return (
    <div
      className="stat-card"
      onClick={() => {
        navigate(navito);
      }}
    >
      <div className="card-header">
        <h3 className="card-title">{title}</h3>
        {/* <div className={`card-icon ${getColorClass(color)}`}>
          {iconMap[icon]}
        </div> */}
      </div>

      <div className="card-content">
        <h2 className="card-value">{value}</h2>
        <div className={`card-icon ${getColorClass(color)}`}>
          {iconMap[icon]}
        </div>
      </div>

      <div className={`card-change ${getChangeClass(changeType)}`}>
        {changeType === "up" && (
          <>
            <TrendingUp size={16} className="change-icon" />
            {/* <span className="change-percentage">{change}</span> */}
          </>
        )}
        {changeType === "down" && (
          <>
            <TrendingUp size={16} className="change-icon down" />
            {/* <span className="change-percentage">{change}</span> */}
          </>
        )}
        {changeType === "neutral" && (
          <>
            <Activity size={16} className="change-icon neutral" />
            <span className="change-percentage">{change}</span>
          </>
        )}
        <span className="change-text">{changeText}</span>
      </div>
    </div>
  );
};

export default Card;
